import React, { useEffect, useState } from 'react';
import "../../styles/devices/mob_SignsTable.css";
import { Button } from "@material-ui/core";
import { useHistory } from 'react-router';
import { useTranslation } from "react-i18next";

export function SubmissionBanner(props) {
    const { device_portrait, origin } = props;
    const { t } = useTranslation("global")

    const [ showSubmissionBanner, setShowSubmissionBanner ] = useState(false)

    useEffect(() => {
        if(device_portrait){
            setShowSubmissionBanner(false)
        }else{
            setShowSubmissionBanner(true)
        }
    }, [device_portrait]);

    const history = useHistory();
    function handleOpenSubmissionScreen(){
        if (!showSubmissionBanner){
            setShowSubmissionBanner(true)
        }else{
            history.push({pathname: "/submission", origin: origin});
        }
    }

    function handleMouseLeave(){
        if(device_portrait){
            setShowSubmissionBanner(false)
        }
    }

    return (
        <div>
            <Button
                // style={{ zIndex: 9, opacity: showSubmissionBanner ? 1 : 0.4 }}
                className={showSubmissionBanner ? "submission" : "submission_minor"}
                onClick={handleOpenSubmissionScreen}
                onMouseLeave={handleMouseLeave}>

                {showSubmissionBanner ? t("sRecordComponent.submit_word").toUpperCase() : t("sRecordComponent.submit_word_short").toUpperCase()}

            </Button>
        </div>
    );
};